import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Helpers } from 'src/app/helpers/helpers';
import { CustomTest, QuestionSchema } from 'src/app/models/custom_test_model';
import { CustomTestService } from 'src/app/services/custom-test.service';
import { TestService } from 'src/app/services/test.service';
import { UserService } from 'src/app/services/user.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import Swal from 'sweetalert2';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
declare var Quill: any;
@Component({
  selector: 'app-custom-test-report',
  templateUrl: './custom-test-report.component.html',
  styleUrls: ['./custom-test-report.component.css']
})
export class CustomTestReportComponent implements OnInit {

  public selectedTest;
  public evaluated;
  public age;
  public form: CustomTest;
  public percentCompleted = 0;
  public isExporting = false;
  constructor(
    private testService: TestService,
    private route: ActivatedRoute,
    private userService: UserService,
    private customTestService: CustomTestService,
    private router: Router
  ) { }

  ngOnInit(): void {
    let testId = this.route.snapshot.paramMap.get('testId');
    if (!testId){
      //TODO return
    }
    this.testService.getTestById(testId).subscribe( async (data)=>{
      this.selectedTest = data;
      
      this.customTestService.getCustomTests({_id: this.selectedTest.completeForm}).subscribe( resp => {
        if (resp[0]){
          this.form = resp[0];
        }
        if (this.form.random){
          let questionsSet = []
          this.selectedTest.formData.map((i)=>{
            questionsSet.push(this.form.questions[i])
          })
          this.form.questions = questionsSet;
        }
        // console.log(this.form.questions)
        let shared = this.route.snapshot.queryParamMap.get('share');
        let showPdf = this.route.snapshot.queryParamMap.get('showPdf');
        if (showPdf && showPdf == 'true'){
          setTimeout(()=>{
            this.generatePdf();
          }, 1000)
        }
        if (shared && !this.selectedTest.public ){
          return Swal.fire({
            icon: 'info',
            text: 'Reporte privado',
            showConfirmButton: false,
            timer: 1500
          }).then(
            resp=>{
              this.router.navigate(['']);
            }
          )
        }
        // console.log(this.form)
      })
      // console.log(this.selectedTest);
      this.userService.getUserByEmail(this.selectedTest.evaluated).subscribe(
        resp=>{
          this.evaluated = resp;
          var fechaInicio = new Date(resp.birthDate).getTime();
          var fechaFin    = new Date(Date.now()).getTime();
          var diff = fechaFin - fechaInicio;
          this.age = Math.round(diff/(1000*60*60*24*365));
        },
        err=>console.log(err)
      )
    });
  }

  getAnswerString(answer: any[]){
    if (answer.length == 0) return 'No respondió';
    let str = '';
    answer.map((ans, index)=>{
      str += ans.answer + (index == answer.length - 1 ? '' : ', ');
    })
    return str;
  }

  getOptionClass(questionIndex: number, answer: any[]){
    let options = this.form.questions[questionIndex].answers;
    let correct = false;
    if (this.form.questions[questionIndex].type == 'multiple'){
      let allCorrects = true;
      let correctLength = 0;
      
      this.form.questions[questionIndex].answers.map((ans)=>{
        if (ans.correct) correctLength++;
      })
      options.map((option)=>{
        if (option.correct && !answer.some((ans)=> ans.answer == option.title)){
          allCorrects = false;
        }
      })
      if (allCorrects && answer.length == correctLength){
        return 'correctans';
      }
      return 'wrong';
    }
    options.map((option)=>{
      if (option.correct && answer.some((ans)=> ans.answer == option.title)){
        correct = true;
      }
    })
    return `${correct ? 'correctans' : 'wrong'}`;
  }

  public async generatePdf(){
    this.percentCompleted = 0;
    this.isExporting = true;
    let logoUrl =  'https://i.imgur.com/EFIjUdn.png';

    scrollTo(1,0);
    let answers = [];

    let i = 0;
    for (let a of this.form.questions){
      i++
      if (this.getOptionClass(i - 1, this.selectedTest.answers[i - 1]) == 'wrong' || a.type == 'conditional' || a.type == 'text'){
        answers.push({
          text:`#${i}`,
          style:'header',
          bold:true,
          margin: [0, 0, 0, 0]
        })
  
        answers.push({
          text:`Descripción`,
          style:'header',
          bold:true,
          margin: [0, 0, 0, 20]
        })
  
  
        answers.push({
          text:Helpers.quillGetHTML(a.instructions).replace(/<[^>]+>/g, ''),
          margin: [0, 0, 0, 20]
        })
  
        answers.push({
          text:`Pregunta`,
          style:'header',
          bold:true,
          margin: [0, 0, 0, 20]
        })
  
  
        answers.push({
          text:Helpers.quillGetHTML(a.question).replace(/<[^>]+>/g, ''),
          margin: [0, 0, 0, 20]
        })
  
        if (a.questionImage){
          answers.push(
            {image:await Helpers.getBase64ImageFromURL(a.questionImage), width:500, alignment:'center', margin:[0,0,0,20]},
          )
        }
  
        answers.push({
          text:`Respuesta del usuario: ${this.getAnswerString(this.selectedTest.answers[i - 1])}`,
          style:'header',
          bold:true,
          margin: [0, 0, 0, 20]
        })
  
        if (a.type != 'conditional'){
  
          let correctAnswer = ``
          a.answers.map((ans)=>{
            if (ans.correct){
              correctAnswer += ans.title + ', ';
            }
          })
    
          answers.push({
            text:`Respuesta correcta: ${correctAnswer}`,
            style:'header',
            bold:true,
            margin: [0, 0, 0, 20]
          })
        }
  
        answers.push({
          text:Helpers.quillGetHTML(a.explanation).replace(/<[^>]+>/g, ''),
          margin: [0, 0, 0, 20]
        })
  
        if (a.answerImage){
          answers.push(
            {image:await Helpers.getBase64ImageFromURL(a.answerImage), width:500, alignment:'center', margin:[0,0,0,20]},
          )
        }
      }


 

    }
    let doc = {
      info:{
        title:`${this.evaluated.name}_${this.evaluated.surname}_${this.form.title}_report.pdf`
      },
      footer: function (currentPage, pageCount) {
        return { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'center' };
      },
      pageMargins: [ 40, 70, 40, 60 ],
      header:{
        columns:[
          {},
          {image:await Helpers.getBase64ImageFromURL(logoUrl), width:100, alignment:'right', margin:[0,10,30,0]},
        ],
      },
      pageSize:'A4',
      content:[
        {
          text: this.form.title,
          bold: true,
          fontSize: 20,
          alignment: 'center',
          margin: [0, 0, 0, 20]
        },
        {
          text:'DATOS PERSONALES DEL EVALUADO',
          style:'header',
          bold:true,
          margin: [0, 0, 0, 10]
        },
        {
          table:{
            body:[
              ['Nombre y apellido: ', this.evaluated.name+" "+this.evaluated.surname],
              ['Sexo: ', this.evaluated.sex],
              ['Edad: ', this.age],
              ['Fecha de nacimiento: ', new DatePipe('es-Ar').transform(this.evaluated.birthDate, 'shortDate')],
              ['Fecha de aplicación: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortDate')],
              ['Hora de inicio: ', new DatePipe('es-Ar').transform(this.selectedTest.startDate, 'shortTime')],
              ['Hora de finalización: ', new DatePipe('es-Ar').transform(this.selectedTest.completeDate, 'shortTime')],
              ['Respuestas acertadas: ', `${this.selectedTest.formScore}/${this.form.questions.length}`],
            ]
          },
          margin:[0, 0, 0, 20]
        },



        {
          text:'LISTADO DE RESPUESTAS',
          style:'header',
          bold:true,
          margin: [0, 0, 0, 20],
        },
        ...answers
      ]
    }
    pdfMake.createPdf(doc).download(`${this.evaluated.name}_${this.evaluated.surname}_${this.form.title}_report.pdf`);

  }

  getTextResponse(value: any){
    if (typeof value == 'string') return value;
    if (Array.isArray(value)) return value.join(', ');
  }

    async share(){
      let url = `${location.origin}/dashboard/custom-test-report/${this.selectedTest._id}?share=true`;
      await navigator.clipboard.writeText(url);
      Swal.fire({
        icon:'success',
        text:'Enlace copiado al portapapeles',
        showConfirmButton: false,
        timer: 1500
      })
    }

    back(){
      window.history.back();
    }

}
